const $ = require('jquery');
import slick from 'slick-carousel';

$("#modules-slider").each(function() {

    var $slider = $(this);

    $slider.find('.module').each(function(index) {
        var $module = $(this);
        // $module.attr('data-wow-offset', 0);
        $module.addClass('wow').addClass('animate__animated').addClass('animate__bounceIn');
        $module.css('animation-delay', (index*100) + 'ms');
    });
        

    $slider.slick({
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1700,
                settings: {
                    arrows: false,
                    dots: true,
                }

            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    arrows: false,
                    dots: true,
                    autoplay: true,
                }
            }, 
            {
                breakpoint: 768,
                settings: {
                    slidesToScroll: 1,
                    slidesToShow: 1,
                    arrows: false,
                    dots: true,
                    autoplay: true,
                    adaptiveHeight: true,
                }
            }
        ]
    });

});
